export const ORDERS_ROUTE_NAMES = {
  BRAND_OWNER_DRAFT_ORDERS: 'brand-owner-draft-orders',
  BRAND_OWNER_EDIT_DRAFT_ORDER: 'brand-owner-edit-draft-order',
  BRAND_OWNER_ORDER_SUMMARY: 'brand-owner-order-summary',
  BRAND_OWNER_ORDERS: 'brand-owner-orders',
  BRAND_OWNER_PRINT_DRAFT_ORDER: 'brand-owner-print-draft-order',
  COLLABORATIVE_RECEIVED: 'collaborative-received',
  COLLABORATIVE_SENT: 'collaborative-sent',
  CREATE_BRAND_OWNER_ORDER: 'create-brand-owner-order',
  CREATE_ORDER: 'create-order',
  CUSTOMER_REQUEST_VIEW: 'customer-request-view',
  CUSTOMER_REQUESTS: 'customer-requests',
  DELETE_DRAFT_ORDER: 'delete-draft-order',
  DELIVERY_ORDER_LOG: 'view-delivery-order-log',
  EDIT_ORDER: 'edit-order',
  EDIT_ORDER_SALES_REPS: 'edit-order-sales-reps',
  INTERNAL_APPROVALS_LIST: 'internal-approvals-list',
  ORDER_CLONE: 'order-clone',
  ORDER_INVOICE: 'order-invoice',
  ORDER_INVOICE_SEND_EMAIL: 'send-invoice-email',
  ORDER_INVOICE_WITH_SLUG: 'order-invoice-with-slug',
  ORDER_LOG: 'order-log',
  ORDER_PAYMENTS: 'order-payments',
  ORDER_RETURN_CREATE: 'order-return-create',
  ORDER_RETURN_EDIT: 'order-return-edit',
  ORDER_RETURN_SUMMARY: 'order-return-summary',
  ORDER_RETURNS: 'order-returns',
  ORDER_SPLIT: 'order-split',
  ORDER_SUMMARY: 'order-summary',
  ORDER_SUMMARY_VUE: 'order-summary-vue',
  ORDER_SUMMARY_WITH_SLUG: 'order-summary-with-slug',
  ORDER_VIEW_LOG: 'view-order-log',
  ORDERS_DRAFT: 'orders-draft',
  ORDERS_PRINT: 'orders-print',
  ORDERS_RECEIVED: 'orders-received',
  ORDERS_SENT: 'orders-sent',
  REORDER_ORDER: 'reorder-order',
  REVIEW_ORDER: 'review-order',
  UPLOADED: 'uploaded-purchase-orders',
};
